import { render } from "./PortalDashboard.vue?vue&type=template&id=c6740426&scoped=true&ts=true"
import script from "./PortalDashboard.vue?vue&type=script&lang=ts"
export * from "./PortalDashboard.vue?vue&type=script&lang=ts"

import "./PortalDashboard.vue?vue&type=style&index=0&id=c6740426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6740426"]])

export default __exports__